import { Observable } from "rxjs"
import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function RandomSelectionListPrintGetObservable(poolId: number, poolSelectionId: number, accountID: number): Observable<string> {
  const params: string = JSON.stringify({
    ClientDetails: {},
    GetRandomSelectionList: {
      Extra: "false",
      PageSize: 25,
      PoolID: poolId,
      PoolMembersID: [],
      PoolSelectionID: poolSelectionId,
      ProfileAccountID: accountID,
      ProfileAccountTypeID: AccountTypeID
    }
  })

  return ObservableFromFetch<string>("WorkforceReport/RandomSelectionListReport", params)
}
